<template>
    <div class="home container">
        <div class="row justify-content-center">
            <div class="col-12 mb-3" style="text-align:right">
                <button type="button" class="btn btn-outline-primary" @click="downloadAndZip()" v-if="this.signedCertificates.length > 0" :disabled="this.downloadCount >0">
                    <font-awesome-icon icon="file-archive" /> {{downloadZipButtonText}}
                </button>
                <router-link :to="{ name: 'Admin' }" class="btn btn-outline-primary" v-if="activeUser.super"> <font-awesome-icon icon="cogs" /> Admin</router-link>
                <router-link :to="{ name: 'Courses' }" class="btn btn-outline-primary" v-if="activeUser.super || activeUser.admin || activeUser.manager"> <font-awesome-icon icon="chalkboard-teacher" /> Cursos</router-link>
                <!-- Upload CSV -->
                <button type="button" class="btn btn-outline-primary" @click="toggleUploadCVS()">
                    <font-awesome-icon icon="plus" /> Subir CVS
                </button>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-primary" @click="toggleModal()">
                    <font-awesome-icon icon="plus" /> Agregar
                </button>
            </div>
            <div class="col-12 col-md-12 col-lg-12">
                <ListCert />
            </div>

            <!-- Modal add new cert -->
            <ModalUploadCSV />
            <ModalAddCertificate />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import ListCert from "@/components/ListCert.vue"
import ModalAddCertificate from "@/components/ModalAddCertificate.vue"
import ModalUploadCSV from "@/components/ModalUploadCSV.vue"
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
import { es } from "vuejs-datepicker/src/locale"
import Promise from 'bluebird'
import JsZip from 'jszip'
import FileSaver from 'file-saver'

export default {
    name: "Dashboard",
    data() {
        return {
            showBtn: false,
            userId: firebase.auth().currentUser.uid,
            certData: {},
            courseDoc: "",
            verifyUrl: "",
            certId: 0,
            colId: firebase.auth().currentUser.uid,
            downloadZipButtonText: 'Descargar Diplomas Firmados',
            downloadCount: 0,
            showItems:70,
            lastItem:0
        }
    },
    computed: {
        ...mapGetters({
            courses: 'activeCourses',
            activeUser: 'currentUser',
            signedCertificates: 'signedCertificates',
            getCourseData: 'getCourseData'
        }),
        filesToDownload(){
            const filesArray = []
            for (const certificate of this.signedCertificates) {
              if (certificate.certUri && certificate.sigUri) {
                filesArray.push({
                    downloadUrl: certificate.certUri,
                    ownerName: `${certificate.name} ${certificate.lastname}`,
                    fileExtension: 'pdf',
                    id: certificate.id
                })

                filesArray.push({
                    downloadUrl: certificate.sigUri,
                    ownerName: `${certificate.name} ${certificate.lastname}`,
                    fileExtension: 'sig',
                    id: certificate.id
                })
              }
            }
            return filesArray
        }
    },
    created() {
        this.getCourses()
    },
    methods: {
        ...mapActions({
            getCourses: 'getCourses'
        }),
        toggleUploadCVS() {
          this.$store.dispatch("toggleModalUploadCSV")
        },
        toggleModal() {
            this.$store.dispatch("toggleModalAddCertificate")
        },
        download (url) {
            return fetch(url).then(resp =>
                resp.blob()
            ).catch(err => {
                console.log(err)
            });
        },
        downloadByGroup (files, files_per_group=10) {
            return Promise.map(
                files,
                async file => {
                    return await this.download(file.downloadUrl)
                },
                {concurrency: files_per_group}
            );
        },
        exportZip (blobs) {
          let lengthFiles = (this.filesToDownload).length;
          lengthFiles = lengthFiles/this.showItems
          lengthFiles = Math.ceil(lengthFiles)
          for (let index = 1; index <= lengthFiles; index++) {
            let firstItem = (this.lastItem == 0) ? 0 : this.lastItem ;
            let lastItem = firstItem + this.showItems + 1;

            const zip = JsZip();
            const filesQueue = this.filesToDownload;
            const signedCertificates = this.signedCertificates;
            blobs.forEach((blob, i) => {
                if (i >=  firstItem && lastItem >= i) {
                  zip.file(`${filesQueue[i].ownerName}-${filesQueue[i].id}.${filesQueue[i].fileExtension}`, blob);
                  this.lastItem++;
                }
            });
            zip.generateAsync({type: 'blob'}).then(zipFile => {
                this.downloadZipButtonText = 'Descargar Diplomas Firmados'
                this.downloadCount = 0;
                const fileName = `Diplomas Firmados - ${this.signedCertificates[0].course}.zip`;
                return FileSaver.saveAs(zipFile, fileName);
            });
          }
          this.$toasted.clear()
          this.$toasted.show('Descarga finalizada', {
            type : 'info',
            duration : null,
          })
        },
        downloadAndZip () {
            this.downloadCount = 0
            this.$toasted.clear()
            this.$toasted.show('Descarga de diplomas inicializada, no recargue su navegador', {
                type : 'info',
                duration : null,
                action: {}
            });
            return this.downloadByGroup(this.filesToDownload, 5).then(this.exportZip);
        }
    },
    components: {
        ListCert,
        Datepicker,
        ModalUploadCSV,
        ModalAddCertificate
    }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue